module.exports = __webpack_public_path__ + "img/admin-dashboard-2.3d8bafe3.jpg";